import { RefObject } from 'react';

export const CARD_WIDTH = 169;
export const CARDS_VISIBLE = 4;
export const GAP = 24;

export const getGapBetweenCards = (
  refCards: RefObject<HTMLDivElement>,
  cardClassName = 'vitrine-template1__card',
) => {
  // initial value
  let gap = 24;
  let cardWidth = 169;

  const cardsDiv = refCards.current?.getElementsByClassName(cardClassName);
  if (cardsDiv && cardsDiv.length > 0) {
    const firstCard = cardsDiv[0] as HTMLAnchorElement;
    gap = Number(getComputedStyle(firstCard).marginRight.replace('px', ''));

    cardWidth = Math.round(
      Number(getComputedStyle(firstCard).width.replace('px', '')),
    );

    if (cardWidth + gap) {
      return cardWidth + gap;
    }
  }

  return 169 + 24;
};

export const getCardWidth = (
  refCards: RefObject<HTMLDivElement>,
  cardClassName = 'vitrine-template1__card',
) => {
  return getGapBetweenCards(refCards, cardClassName);
};

export const checkScrollLimit = (
  cardWidth: number,
  scrollX: number,
  cardAmount: number,
  cardsInView: number,
) => {
  const limitScroll = cardWidth * cardAmount;
  const currentScrollX = cardWidth * cardsInView + scrollX;
  return currentScrollX >= limitScroll;
};
